import React, { useEffect, useState } from "react";
import LoadingGif from "@public/img/loading.gif";
import bookmarkOnIcon from "@public/img/bookmark-on.svg";
import MovieCard from "@/component/commom/movie-card";
import PaginationView from "@/component/commom/pagination";
import { Movie } from "@/entry/server/movie";
import { Pagination } from "@/lib/api";
import { userRepo } from "@/repo/user-repo";

export default function FavoritesPage() {
  const [movies, setMovies] = useState<Movie[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState<Pagination | undefined>(undefined);

  useEffect(function () {
    setLoading(true);
    userRepo.getFavorites(page).then(function (res) {
      setMovies(res.data ? res.data : []);
      setPagination(res.pagination ? res.pagination : undefined);
      setLoading(false);
    });
  }, [page]);

  var bodyClassName = "profile-panel__body";
  if (loading || movies.length === 0) {
    bodyClassName = bodyClassName + " profile-panel__body--center";
  }

  return (
    <div className="profile-panel">
      <h2 className="profile-panel__title">مورد علاقه ها</h2>

      <div className={bodyClassName}>
        {loading && (
          <div className="profile-panel__loading">
            <img src={LoadingGif} alt="loading" />
          </div>
        )}

        {!loading && movies.length === 0 && (
          <div className="profile-panel__empty">
            <img src={bookmarkOnIcon} alt="" className="profile-panel__empty-icon" />
            <p className="profile-panel__empty-title">
              <span className="profile-panel__empty-title-accent">موردی</span> یافت نشد
            </p>
            <p className="profile-panel__empty-desc">
              هنوز فیلم یا سریالی به علاقه‌مندی‌های خود اضافه نکرده‌اید.
            </p>
          </div>
        )}

        {!loading && movies.length > 0 && (
          <div className="profile-panel__grid">
            {movies.map(function (movie) {
              return (
                <MovieCard
                  key={movie.id}
                  id={movie.id}
                  slug={movie.slug}
                  type={movie.type}
                  title={movie.title}
                  updateText={movie.update_text}
                  year={movie.year != null ? String(movie.year) : ""}
                  ratingValue={movie.imdb_rate != null ? String(movie.imdb_rate) : "0"}
                  thumbnail={movie.thumbnail}
                  isDubbed={movie.is_dubbed}
                  isSubtitled={movie.is_subbed}
                  genres={movie.genres ? movie.genres : []}
                />
              );
            })}
          </div>
        )}
      </div>

      {pagination && (
        <div className="profile-panel__pagination">
          <PaginationView pagination={pagination} black onChange={setPage} />
        </div>
      )}
    </div>
  );
}
